import { LoadingOutlined } from '@ant-design/icons';
import { cn } from '@components/shadcn/utils';
import { Spin } from 'antd';

const LoadingCards = ({ title, className }: { title: string; className?: string }) => {
  return (
    <div className={cn('w-full h-full flex items-center gap-4 justify-center ', className)}>
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 24 }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            spin
          />
        }
      />
      <h3 className="typo typo--title-2">{title}</h3>
    </div>
  );
};

export default LoadingCards;
